<template>
  <v-card class="rounded-lg">
    <v-data-table
      :headers="headers"
      :items="encounters"
      sort-by="order"
      class="elevation-1"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Encounters Config</v-toolbar-title>
          <v-spacer/>
          <v-dialog v-model="dialog" max-width="700px" persistent>
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">New Value</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" class="pb-0">
                    <v-text-field
                      v-model="editedItem.name"
                      label="Name"
                      v-validate="{
                        required: true
                      }"
                      name="name"
                      :error-messages="errors.collect('name')"
                    />
                  </v-col>
                  <v-col cols="12" class="pb-0">
                    <v-text-field
                      v-model="editedItem.mc_start_narration_node"
                      label="Start narration node"
                      v-validate="{
                        required: true
                      }"
                      name="start narration node"
                      :error-messages="errors.collect('start narration node')"
                    />
                  </v-col>
                  <v-col cols="12" class="pb-0">
                    <v-text-field
                      v-model="editedItem.mc_finish_narration_node"
                      label="Finish narration node"
                      v-validate="{
                        required: true
                      }"
                      name="finish narration node"
                      :error-messages="errors.collect('finish narration node')"
                    />
                  </v-col>
                  <v-col cols="12" class="pb-0">
                    <v-select
                      v-model="editedItem.map_name"
                      :items="mapNames"
                      label="Map name"
                      clearable
                    />
                  </v-col>
                  <v-col cols="12" class="pb-0">
                    <v-switch
                      v-model="editedItem.optional"
                      label="Optional"
                      hide-details
                    />
                    <v-switch
                      v-model="editedItem.finish"
                      label="Game finish"
                      hide-details
                    />
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer/>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" dark @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.order="{ item }">
        <v-btn
          text
          fab
          outlined
          x-small
          @click="editOrder(item)"
        >
          {{ item.order }}
        </v-btn>
      </template>
      <template v-slot:item.optional="{ item }">
        <v-chip small
          :color="item.optional ? 'green' : 'grey'"
          dark
        >
          {{ item.optional ? 'Yes' : 'No' }}
        </v-chip>
      </template>
      <template v-slot:item.finish="{ item }">
        <v-chip small
          :color="item.finish ? 'green' : 'grey'"
          dark
        >
          {{ item.finish ? 'Yes' : 'No' }}
        </v-chip>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          small
          @click="editItem(item)"
        >
          <v-icon
            small
          >
            {{ mdiPencil }}
          </v-icon>
        </v-btn>
        <v-btn
          icon
          small
          @click="deleteRequest(item)"
        >
          <v-icon
            small
          >
            {{ mdiDelete }}
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog v-model="orderDialog" max-width="400px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Edit order for {{ this.editedItem.name }}</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="editedItem.order"
            label="Order"
            type="number"
            :max="this.encounters.length"
            min="1"
            hide-details
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="blue darken-1" dark @click="saveOrder">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mdiPencil, mdiDelete } from '@mdi/js';
export default {
  data () {
    return {
      mdiPencil,
      mdiDelete,
      dialog: false,
      orderDialog: false,
      headers: [
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Start narration node', value: 'mc_start_narration_node', sortable: false },
        { text: 'Finish narration node', value: 'mc_finish_narration_node', sortable: false },
        { text: 'Order', value: 'order', align: 'center' },
        { text: 'Map name', value: 'map_name' },
        { text: 'Optional', value: 'optional' },
        { text: 'Game finish', value: 'finish' },
        { text: 'Actions', value: 'actions', align: 'center', sortable: false }
      ],
      mapNames: [],
      encounters: [],
      editedIndex: -1,
      editedItem: {
        name: null,
        mc_start_narration_node: null,
        mc_finish_narration_node: null,
        order: null,
        optional: false,
        finish: false,
        map_name: null
      },
      defaultItem: {
        name: null,
        mc_start_narration_node: null,
        mc_finish_narration_node: null,
        order: null,
        optional: false,
        finish: false,
        map_name: null
      }
    }
  },
  mounted () {
    this.fetchMapNames()
    this.fetchEncounters()
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    orderDialog (val) {
      val || this.close()
    }
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Value' : 'Edit Value';
    }
  },
  methods: {
    close () {
      this.dialog = false;
      this.orderDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    editItem (item) {
      this.editedIndex = this.encounters.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    editOrder (item) {
      this.editedIndex = this.encounters.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.orderDialog = true
    },
    async fetchMapNames () {
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/configs/multi-map/all-map-names`
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.mapNames = data
      }
    },
    async fetchEncounters () {
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/configs/telemetry/encounters`
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.encounters = data
      }
    },
    async save () {
      const isValid = await this.$validator.validateAll()
      if (isValid) {
        if (this.editedIndex > -1) {
          await this.updateRequest()
        } else {
          await this.createRequest()
        }
      }
    },
    async createRequest () {
      const { data } = await this.$axios.post(
        this.$store.getters.projectPath + '/configs/telemetry/encounter',
        { ...this.editedItem, order: this.encounters.length + 1 }
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.encounters.push(data)
        this.close()
      }
    },
    async updateRequest () {
      const { data } = await this.$axios.put(
        this.$store.getters.projectPath + '/configs/telemetry/encounter/' + this.editedItem.id,
        this.editedItem
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.$set(this.encounters, this.editedIndex, data)
        this.close()
      }
    },
    async deleteRequest (item) {
      const { data } = await this.$axios.delete(
        this.$store.getters.projectPath + '/configs/telemetry/encounter/' + item.id
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        const index = this.encounters.indexOf(item)
        this.encounters.splice(index, 1)
        this.$toasted.success('Successfully deleted')
      }
    },
    async saveOrder () {
      this.editedItem.order = parseInt(this.editedItem.order)
      const { data } = await this.$axios.put(
        this.$store.getters.projectPath + '/configs/telemetry/encounters',
        {
          order: parseInt(this.editedItem.order),
          id: this.editedItem.id
        }
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.encounters.splice(this.editedIndex, 1)
        this.encounters.splice(this.editedItem.order - 1, 0, this.editedItem)

        this.encounters = this.encounters.map((item, index) => {
          item.order = index + 1
          return item
        })
        this.$toasted.success('Order successfully changed')
        this.close()
      }
    }
  }
}
</script>